/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import React from 'react';
import Form from 'react-bootstrap5/Form';

import {
  ErrorMessage,
  useField,
} from 'formik';

import Select from '../Select';

export default function HorizontalSelectField(props) {
  const {
    options,
    name,
    label,
    isMulti = false,
    placeholder = 'Select',
    required,
    hint,
    ...rest
  } = props;

  const [field,, helpers] = useField(props);
  const { setValue, setTouched } = helpers;

  function onChange(option) {
    setValue(option ? option.map((item) => item.value) : []);
  }

  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    }
    return isMulti ? [] : '';
  };

  if (!isMulti) {
    return (
      <Form.Group className="mb-3" controlId="formBasicEmail">
        {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
        )}
        <Select
          id={field.name}
          options={options}
          name={field.name}
          value={
              options
                ? options.find((option) => option.value === field.value) || null
                : null
            }
          onChange={(option) => {
            setTouched(true);
            setValue(option ? option.value : null);
          }}
          onBlur={() => {
            setTouched(true);
          }}
          placeholder={placeholder}
          {...rest}
        />
        {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
        <ErrorMessage
          name={name}
          render={(msg) => (
            <Form.Control.Feedback
              style={{ display: 'block' }}
              type="invalid"
            >
              {msg}
            </Form.Control.Feedback>
          )}
        />
      </Form.Group>
    );
  }
  return (
    <Form.Group className="mb-3" controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}
      <Select
        id={field.name}
        name={field.name}
        value={getValue()}
        onChange={onChange}
        options={options}
        isMulti
        placeholder={placeholder}
        {...rest}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      <ErrorMessage
        name={name}
        render={(msg) => (
          <Form.Control.Feedback
            style={{ display: 'block' }}
            type="invalid"
          >
            {msg}
          </Form.Control.Feedback>
        )}
      />
    </Form.Group>
  );
}
